import React, { useState, useEffect } from 'react';

import BuilderHeader from '../backend/BuilderHeader';
import BuilderHeaderSimple from '../backend/BuilderHeaderSimple';

import BuilderMainMenu from '../backend/BuilderMainMenu';

import Spinner from './Spinner';

const WrapperNotPromotion = (props) => {
	const has_tabs = props?.has_tabs ?? true;
	const header_props = props?.header_props || {};

	let cont_classes = ['gui_whole_builder_contents', 'outside_builder', 'without_menu'];

	let contents_classes = ['builder_main', ((has_tabs) ? 'with_tabs' : 'without_tabs')];

	return (
		<>
			<BuilderHeaderSimple {...header_props} />

			<div class={cont_classes.join(" ")}>
				<div class={contents_classes.join(" ")}>
					{props.children}
				</div>
			</div>
		</>
	)
};

const WrapperPromotion = (props) => {
	const [ pinned_menu, setPinnedMenu ] = useState(true);

	const changePinMenu = (is_pinned) => {
		setPinnedMenu(is_pinned);
	};

	const has_tabs = props?.has_tabs ?? true;
	const header_props = props?.header_props || {};

	const cont_classes = ['gui_whole_builder_contents', 'outside_builder'];
	if(pinned_menu) cont_classes.push('with_pinned_menu');

	const contents_classes = ['builder_main', ((has_tabs) ? 'with_tabs' : 'without_tabs')];

	return (
		<>
			<BuilderHeader
				{...header_props}
				promoType={window?.actual_promotion_type ?? null}
				pm={props.pm}
			/>

			<div class={cont_classes.join(" ")}>
				<div class={contents_classes.join(" ")}>
					{props.children}
				</div>

				<BuilderMainMenu
					promoType={window?.actual_promotion_type ?? null}
					pm={props.pm}
					questions={props?.pm?.questions ?? null}
					onTogglePin={changePinMenu}
				/>
			</div>
		</>
	)
};

export const EmptyBuilderMain = (props) => {
	return (
		<WrapperPromotion {...props}>
			<div class="empty_builder_cont main_bg is_fullscreen relative_to_container">
				<div class="not_awesome gui_text_align_center" style={{maxWidth:'35em'}}>
					{props.children}
				</div>
			</div>
		</WrapperPromotion>
	)
};

export const BuilderMainWithoutSidebar = (props) => {
	const not_padded = props?.not_padded ?? false;

	let _props = {...props};
	if(_props.main_classes == undefined) _props.main_classes = '';
	_props.main_classes += ' builder_whole_cont';
	if(props?.full_main_bg ?? true) _props.main_classes += ' main_bg';
	if(!not_padded) _props.main_classes += ' gui_is_padded_huge';

	_props.has_tabs = props?.has_tabs ?? false;

	return (
		<BuilderMain {..._props} />
	)
};

export const BuilderMainNotPromotion = (props) => {
	return (
		<BuilderMain
			{...props}
			has_promotion={false}
			with_menu={false}
		/>
	)
};

const BuilderMain = (props) => {
	const [ loading, setLoading ] = useState(true);

	useEffect(() => {
		setLoading(false);
	}, []);

	const has_tabs = props?.has_tabs ?? true;
	const main_classes = [(props.main_classes != undefined) ? props.main_classes : 'builder_cont'];

	const has_promotion = props?.has_promotion ?? true;
	const Wrapper = (has_promotion) ? WrapperPromotion : WrapperNotPromotion;

	return (
		<Wrapper {...props}>
			{(has_tabs) && (
				<nav id="nav_tabs" style={{position:'relative', zIndex:'3'}} aria-label='section sub-navigation' />
			)}

			<div class={main_classes.join(" ")}>
				{(!loading) && (
					props.children
				)}

				{(loading) && (
					<Spinner>Loading section</Spinner>
				)}
			</div>
		</Wrapper>
	)
};

export default BuilderMain;